import React from "react";
import { OperatorDashboard } from "../interfaces/OperatorDashboard";
import { OperatorDashboardEscrowTable } from "./OperatorDashboardEscrowTable";
import { OperatorDashboardSCTable } from "./OperatorDashboardSCTable";
import { InstitutionAttributesMap } from "../interfaces/Institution";

type OperatorDashboardTableProps = {
    operatorDashboard: OperatorDashboard
    attributes?: InstitutionAttributesMap | null
}

export const OperatorDashboardTable = ({ operatorDashboard, attributes }: OperatorDashboardTableProps) => {

    const operatorInfos = operatorDashboard?.operator_infos || [];
    const instanceInfos = operatorDashboard?.instance_infos || [];

    return (
        <>
            <OperatorDashboardEscrowTable escrowInfos={operatorInfos} attributes={attributes}/>
            <OperatorDashboardSCTable scInfo={instanceInfos} attributes={attributes}/>
        </>
    );
}